module.exports = __webpack_public_path__ + "static/media/thumbs-down-gameweek.9be66bcb.png";